export class ApplyEligibilityCheckResponse {
    Error: string;
    Ready: boolean;
    KXStudentGuid: string;
}